import { render, staticRenderFns } from "./appApprovals.vue?vue&type=template&id=21bf2094&scoped=true"
import script from "./appApprovals.vue?vue&type=script&lang=js"
export * from "./appApprovals.vue?vue&type=script&lang=js"
import style0 from "./appApprovals.vue?vue&type=style&index=0&id=21bf2094&prod&scoped=true&lang=scss"
import style1 from "./appApprovals.vue?vue&type=style&index=1&id=21bf2094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf2094",
  null
  
)

export default component.exports